/*
 * json.js
 * json的实现，这辈子估计也没有时间实现了
 */
export default {
  getItem(key){},
  setItem(key, value){},
  removeItem(key){},
  getAll(){},
  clear(){},
  key(n){},
  forEach(cb){},
  has(key){},
  deleteAllExpires(){}
}



// WEBPACK FOOTER //
// ./src/components/storage/json.js